import { ExcursionPage } from '@/app/pages/excursion/excursion-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const excursionSearchSchema = z.object({
  travelId: z.string(),
  excursionId: z.string(),
  date: z.string(),
  adults: z.number(),
  childAges: z.array(z.number()).optional(),
  dateFrom: z.string(),
  dateTo: z.string(),
  cityId: z.string({ coerce: true }),
  cityName: z.string().optional(),
  regionName: z.string().optional(),
  timeZone: z.string(),
  excursionDrawer: z.boolean().optional(),
  bookingType: z.enum(['your-tour', 'accommodation', 'excursion']),
  scenarioName: z.string().optional(),
});

export const Route = createFileRoute('/excursion/')({
  component: ExcursionPage,
  validateSearch: excursionSearchSchema,
});
